import { Hotel } from "../Services/bookingSearch";
import { bookingEngine } from "../Services/wsSearch";
import { hotelCensus } from "./iNft";

export enum COLLECTION_TYPE {
  experience = "experience",
  hotel = "hotel",
}

export type PublicContact = {
  type: "phone" | "website" | "whatsapp" | "email";
  value: string;
};

export type hotelReviewsInfo = {
  reviewCount: number;
  reviewScore: number;
  reviewScoreWord: string;
  reviews: {
    languagecode: string;
    title: string;
    pros: string;
    cons: string;
    average_score: number;
    author: {
      name: string;
      countrycode: string;
    };
    pros_translated?: string;
    title_translated?: string;
    cons_translated?: string;
    date: string;
    review_id: string;
  }[];
  scores: any;
  description: any;
};

export type mongoDbLocation = {
  type: "Point";
  coordinates: [number, number]; // [lng, lat]
};

type BookingEngineSpecs = {
  engine: string;
  redirectParams: {
    hotelId: string;
    channelId: string;
    otherId: string;
  };
  engineParams: any;
};

export type googleLocation = {
  label: string;
  html_label: string;
  place_id?: string;
  address_components?: {
    long_name: string;
    short_name: string;
    types: string[];
  }[];
  coordinates?: {
    lat: number;
    lng: number;
  };
  utc_offset?: number;
  google_maps_url?: string;
};

export type PriceSample = {
  price: number;
  currency: string;
  arrivalDate: Date;
  departureDate: Date;
};

export type PriceServices = {
  hotelscom?: { id: string };
  expedia?: { id: string };
  channelManager?: { id: string };
  hyperguest?: { id: string };
  simplebooking?: { id: string };
  xotelo?: { id: string };
  ermeshotels?: { ca_id: string; ho_id: string };
};

export type priceProviders = {
  bookingEngine?: {
    type: bookingEngine;
    params: any;
  };
  hotelscom?: { id: string };
  bookingcom?: { id: string };
};

export type hotelProperty = {
  accuratePropertyClass: number;
  countryCode: string;
  name: string;
  isPreferred: boolean;
  images: string[];
  currency: string;
  ufi: number;
  propertyClass: number;
  qualityClass: number;
  distance_to_cc: number;
  address: string;
  city: string;
  country: string;
  currency_code: string;
  spoken_languages: string[];
  facilities: { id: number; instances: Array<{ title: string }> }[];
  checkin: { fromTime: string; untilTime: string };
  checkout: { fromTime: string; untilTime: string };
  description: Array<{ languagecode: string; description: string }>;
};

export const locationTypes = [
  "city",
  "lake",
  "mountain",
  "sea",
  "wellness",
  "countryside",
] as const;

export type hotelCensusLocationType = (typeof locationTypes)[number];

export default interface iCollection {
  _id: string;
  name: string;
  website?: string;
  stars?: string;
  phone?: string;
  email?: string;
  locationType?: hotelCensusLocationType;
  cin?: string;
  cir?: string;
  slug?: string;
  type?: COLLECTION_TYPE;
  census: hotelCensus;
  images: Array<string>;

  isActive: boolean | null;

  bookingEngine: string;

  preData: {
    bookingComId?: string;
    deltaPriceBookingCom?: number;
    deltaPriceHotelsCom?: number;
    advantagesOnDirectWebsite: string[];
  };
  isLoyaltyEnabled?: boolean;
  isOnboardingComplete?: boolean;
  isLoyaltyEnabledAdmin?: boolean;
  loyatyDiscountPercentage?: number;
  _bookingComData?: Hotel;
  priceProviders?: priceProviders;
  directsearchData: {
    searchScore?: number;
    meanPrice?: number;

    priceServices?: PriceServices;
    property: hotelProperty;
    priceData?: {
      booking: {
        indicativePrice: { value: number; currency: string };
        updatedAt: Date;
      };
    };
    reviewData?: hotelReviewsInfo;
    mongoDbLocation: mongoDbLocation;
    googleLocation?: googleLocation;
    bookingEngine?: BookingEngineSpecs;
    priceSamples?: { booking: PriceSample[] };
  };
}
